import React, { useEffect, useState, useRef } from "react";
import Header from "../../components/ui/Header";
import Button from "../../components/ui/Button2";
import CategoryGrid from "pages/home-page/components/CategoryGrid";
import { useDispatch } from "react-redux";
import {
  getAdvertismentService,
  getCategoriesService,
  getMyCartService,
  getStoreInfoService,
} from "redux/services/general_service";
import FeaturedProducts from "pages/home-page/components/FeaturedProducts";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Footer from "components/common/Footer";

const Home = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const isRTL = i18n.language === "ar";

  const articles = [
    {
      id: 1,
      title: "What is a Pomeranian? How to Identify Pomeranian Dogs",
      description:
        "The Pomeranian, also known as the Pomeranian (Pom dog), is always in the top of the cutest pets. Not only that, the small, lovely, smart, friendly, and skillful circus dog breed.",
      image: "assets/images/art1.png",
      category: "Pet knowledge",
    },
    {
      id: 2,
      title: "Dog Diet You Need To Know",
      description:
        "Dividing a dog's diet may seem simple at first, but there are some rules you should know so that your dog can easily absorb the nutrients in the diet. For those who are just starting to raise dogs, especially newborn puppies with relatively weak resistance.",
      image: "assets/images/art2.png",
      category: "Pet knowledge",
    },
    {
      id: 3,
      title:
        "Why Dogs Bite and Destroy Furniture and How to Prevent It Effectively",
      description:
        "Dog bites are common during development. However, no one wants to see their furniture or important items being bitten by a dog.",
      image: "assets/images/art3.png",
      category: "Pet knowledge",
    },
  ];

  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    dispatch(getCategoriesService({ page: 1 }));
    dispatch(getStoreInfoService());
    dispatch(getMyCartService());
    dispatch(getAdvertismentService({ page: 1 }));
  }, []);

  const heroRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!heroRef.current) return;
      const heroHeight = heroRef.current.offsetHeight;

      if (window.scrollY >= heroHeight) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="w-full bg-global-4">
      {/* Hero Section */}
      <section
        ref={heroRef}
        className="w-full bg-[linear-gradient(134deg,#fbeed4_0%,#fbeed4_50%,#ffe6b9_100%)] rounded-b-[40px] relative overflow-hidden"
      >
        <div className="w-full max-w-[1440px] mx-auto">
          {/* Header */}
          <Header isScrolled={isScrolled} />
          {/* Hero Content */}

          <div
            dir="ltr"
            className="relative px-4 lg:px-8 pb-[50px] lg:pb-[160px] sm:pb-[0px] mt-[-20px] sm:mt-[10px] lg:mt-[100px] h-[550px] sm:h-[370px] lg:h-[440px]"
          >
            <div className="absolute bottom-[220px] sm:top-[0px] lg:top-[150px] right-0 w-[380px] sm:w-[570px] lg:w-[760px] sm:h-[370px]">
              <div className="absolute w-[320px] sm:w-[480px] lg:w-[640px] h-[180px] sm:h-[370px] lg:h-[400px] rounded-[40px] sm:rounded-[60px] lg:rounded-[0px]  lg:bottom-[-10px] bottom-[-240px] overflow-hidden">
                <img
                  src="assets/images/rec1.png"
                  className="w-full h-full object-cover"
                  style={{ zIndex: 9 }}
                  alt=""
                />
              </div>
              <img
                src="assets/images/img_rectangle_2.png"
                className="absolute object-cover rounded-[16px] mt-4px lg:mt-[-180px]"
                style={{ zIndex: 10 }}
                alt="Background"
              />
              <img
                src="assets/images/img_rectangle_6.svg"
                className={`absolute top-[8px] sm:top-[12px] lg:top-[-145px] w-[16px] sm:w-[24px] lg:w-[32px] h-[16px] sm:h-[24px] lg:h-[32px] rounded-[4px] "left-[80px] sm:left-[120px] lg:left-[160px]`}
                alt="Decoration"
              />
              <img
                src="assets/images/img_rectangle_7.svg"
                className={`absolute top-[14px] sm:top-[22px] lg:top-[-150px] w-[14px] sm:w-[20px] lg:w-[26px] h-[14px] sm:h-[20px] lg:h-[26px] rounded-[3px] left-[82px] sm:left-[125px] lg:left-[165px]`}
                alt="Decoration"
              />
            </div>

            {/* Main Hero Image */}
            <div className="absolute bottom-[0px] sm:bottom-[60px] lg:bottom-[0px] right-[-50px] lg:right-[20px] w-[400px] sm:w-[600px] lg:w-[800px] h-[270px] sm:h-[400px] lg:h-[530px]">
              <img
                src="assets/images/img_good_humored_wo.png"
                className="absolute w-full h-full object-cover"
                style={{ zIndex: 13 }}
                alt="Happy woman with pet"
              />
            </div>

            {/* Text Content - مخفي على الشاشات الصغيرة */}
            <div className="relative z-10 pt-[-200px] sm:pt-[-20px] lg:pt-[0px] max-w-[550px]">
              <h1 className="text-global-3 text-[42px] sm:text-[38px] lg:text-[50px] lg:pl-[100px] font-svn-gilroy font-extrabold leading-[50px] sm:leading-[40px] lg:leading-[52px] mx-auto text-global-text3 capitalize ">
                {t("one_more_friend")}
              </h1>

              <h2 className="text-global-3 text-[30px] sm:text-[30px] lg:text-[40px] lg:pl-[100px] font-svn-gilroy font-bold leading-[22px] sm:leading-[32px] lg:leading-[42px] text-global-text3 capitalize pb-[30px] sm:mb-[90px] lg:mb-[50px] mx-auto">
                {t("thousands_more_fun")}
              </h2>

              <p className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[18px] sm:leading-[21px] lg:leading-[24px] text-global-text5 mb-[30px] sm:mb-[90px] lg:mb-[40px] max-w-[380px] mx-auto">
                {t("having_pet")}
              </p>

              <div className="flex flex-col sm:flex-row gap-[10px] lg:pl-[80px] sm:gap-[15px] lg:gap-[20px] mx-auto">
                <Button
                  variant="outline"
                  onClick={() => {}} // Add required onClick prop
                  className="border border-global-text4 text-global-text4 rounded-[24px] px-[14px] sm:px-[21px] lg:px-[28px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] w-full sm:w-auto justify-center"
                >
                  {t("view_intro")}
                  <img
                    src="assets/images/img_media_playcircle.svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px]"
                    alt=""
                  />
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {}} // Add required onClick prop
                  className="bg-global-text4 text-global-text8 rounded-[24px] px-[17px] sm:px-[26px] lg:px-[34px] py-[7px] sm:py-[11px] lg:py-[14px] w-full sm:w-auto"
                >
                  {t("explore_now")}
                </Button>
              </div>
            </div>

            {/* Decorative Elements */}
            <img
              src="assets/images/img_rectangle_8.png"
              className="absolute bottom-[6px] sm:bottom-[10px] lg:bottom-[0px] left-0 w-[350px] sm:w-[520px] lg:w-[700px] h-[55px] sm:h-[85px] lg:h-[115px] rounded-[28px] sm:rounded-[42px] lg:rounded-[56px]"
              alt="Decorative background"
            />
            <img
              src="assets/images/img_rectangle_5.svg"
              className="absolute top-[150px] sm:top-[130px] lg:top-[0px] right-[300px] sm:right-[460px] lg:right-[620px] w-[8px] sm:w-[12px] lg:w-[16px] h-[8px] sm:h-[12px] lg:h-[16px] rounded-[2px]"
              alt="Small decoration"
            />
          </div>
        </div>
      </section>

      {/* CATEGORY Section */}
      <CategoryGrid />
      {/* Pets Section
      <section className="w-full py-[30px] sm:py-[45px] lg:py-[60px] px-[28px] sm:py-[42px] lg:px-[56px]">
        <div className="w-full max-w-[1182px] mx-auto">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[14px] sm:mb-[21px] lg:mb-[28px]">
            <div className="mb-4 sm:mb-0">
              <p className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text1 mb-[3px] sm:mb-[4px] lg:mb-[6px]">
                Whats new?
              </p>
              <h2 className="text-[18px] sm:text-[21px] lg:text-[24px] font-svn-gilroy font-bold leading-[20px] sm:leading-[23px] lg:leading-[26px] text-global-text4 capitalize">
                Take a look at some of our pets
              </h2>
            </div>
            <Button
              variant="outline"
              onClick={() => {}} // Add required onClick prop
              className="border border-global-text4 text-global-text4 rounded-[22px] px-[24px] sm:px-[36px] lg:px-[48px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[11px] sm:text-[12px] lg:text-[14px]"
            >
              View more
              <img
                src="assets/images/img_arrowright.svg"
                className="w-[15px] sm:w-[18px] lg:w-[20px] h-[15px] sm:h-[18px] lg:h-[20px]"
                alt="Arrow right"
              />
            </Button>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[10px] sm:gap-[15px] lg:gap-[20px]">
            {pets?.map((pet) => (
              <div
                key={pet?.id}
                className="bg-global-6 rounded-[12px] p-[4px] sm:p-[6px] lg:p-[8px] shadow-[0px_4px_28px_#00000014]"
              >
                <div className="bg-global-6 rounded-[10px] p-[4px] sm:p-[6px] lg:p-[8px] mb-[4px] sm:mb-[6px] lg:mb-[8px]">
                  <img
                    src={pet?.image}
                    className="w-full h-[132px] sm:h-[198px] lg:h-[264px] object-cover rounded-[10px]"
                    alt={pet?.name}
                  />
                </div>
                <div className="p-[4px] sm:p-[6px] lg:p-[8px]">
                  <h3 className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-bold leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 mb-[3px] sm:mb-[4px] lg:mb-[6px]">
                    {pet?.name}
                  </h3>
                  <div className="flex justify-between items-center mb-[3px] sm:mb-[4px] lg:mb-[6px]">
                    <div className="flex items-center">
                      <span className="text-[9px] sm:text-[11px] lg:text-[12px] font-svn-gilroy font-medium leading-[10px] sm:leading-[12px] lg:leading-[13px] text-global-text6">
                        Gene:
                      </span>
                      <span className="text-[9px] sm:text-[11px] lg:text-[12px] font-svn-gilroy font-bold leading-[10px] sm:leading-[12px] lg:leading-[13px] text-global-text6 ml-[3px] sm:ml-[4px] lg:ml-[6px]">
                        {pet?.gene}
                      </span>
                    </div>
                    <div className="flex items-center px-[6px] sm:px-[9px] lg:px-[12px]">
                      <span className="text-[9px] sm:text-[11px] lg:text-[12px] font-svn-gilroy font-medium leading-[10px] sm:leading-[12px] lg:leading-[13px] text-global-text6">
                        Age:
                      </span>
                      <span className="text-[9px] sm:text-[11px] lg:text-[12px] font-svn-gilroy font-bold leading-[10px] sm:leading-[12px] lg:leading-[13px] text-global-text6 ml-[3px] sm:ml-[4px] lg:ml-[6px]">
                        {pet?.age}
                      </span>
                    </div>
                  </div>
                  <p className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-bold leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text2">
                    {pet?.price}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>*/}
      {/* Banner Section FOR DESKTO*/}
      <section
        dir="ltr"
        className="hidden sm:block w-full px-4 sm:px-6 lg:px-8 mb-[30px] sm:mb-[45px] lg:mb-[60px]"
      >
        <div className="w-full max-w-[1182px] mx-auto bg-global-text4 bg-global-1 rounded-[20px] relative overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left Side - Image */}
            <div className="w-full lg:w-[50%] bg-[url('assets/images/img_rec1.png')] bg-cover bg-center p-[10px] sm:p-[15px] lg:p-[20px] flex justify-center items-end">
              <img
                src="assets/images/with_owner.png"
                className="w-[256px] sm:w-[384px] lg:w-[512px] h-[171px] sm:h-[257px] lg:h-[342px] object-cover"
                alt="Pet with owner"
                style={{ zIndex: 1000 }}
              />
            </div>

            {/* Right Side - Content */}
            <div className="w-full lg:w-[60%] bg-[url('assets/images/rec_9.png')] bg-cover bg-center p-[28px] sm:p-[42px] lg:p-[56px] flex items-end -ml-0 lg:-ml-[114px]">
              <div className="w-full">
                <div className="flex flex-col gap-[46px] sm:gap-[69px] lg:gap-[92px]">
                  <div className="flex justify-end gap-[10px] sm:gap-[15px] lg:gap-[20px]">
                    <Button
                      variant="outline"
                      onClick={() => {}} // Add required onClick prop
                      className="border border-global-text4 text-global-text4 rounded-[24px] px-[26px] sm:px-[39px] lg:px-[52px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[12px] sm:text-[14px] lg:text-[16px]"
                    >
                      {t("view_intro")}
                      <img
                        src="assets/images/img_arrowright.svg"
                        className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px]"
                        alt="Play icon"
                      />
                    </Button>
                    <Button
                      variant="primary"
                      onClick={() => {}} // Add required onClick prop
                      className="bg-global-text4 text-global-text8 rounded-[24px] px-[17px] sm:px-[26px] lg:px-[34px] py-[7px] sm:py-[11px] lg:py-[14px] text-[12px] sm:text-[14px] lg:text-[16px]"
                    >
                      {t("explore_now")}
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Overlay Content */}
          <div className="absolute top-[30px] sm:top-[45px] lg:top-[60px] left-[42px] sm:left-[63px] lg:left-[84px] right-[42px] sm:right-[63px] lg:right-[84px]">
            <div className="flex flex-col gap-[34px] sm:gap-[51px] lg:gap-[10px] items-end">
              <div className="flex flex-col items-center justify-center text-center">
                <h1 className="text-global-3 text-[26px] pb-[30px] sm:text-[39px] lg:text-[52px] font-svn-gilroy font-extrabold leading-[28px] sm:leading-[41px] lg:leading-[55px]  capitalize">
                  {t("one_more_friend")}
                </h1>
                <h2 className="text-global-3 pb-4 text-[18px] sm:text-[27px] lg:text-[36px] font-svn-gilroy font-bold leading-[19px] sm:leading-[29px] lg:leading-[38px]capitalize">
                  {t("thousands_more_fun")}
                </h2>
                <p className="text-global-3 text-[9px] sm:text-[11px] lg:text-[12px] font-svn-gilroy font-medium leading-[14px] sm:leading-[16px] lg:leading-[18px] text-global-text5 max-w-[190px] sm:max-w-[285px] lg:max-w-[380px]">
                  {t("having_pet")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Banner Section FOR MOBILE*/}
      <section className="w-full px-4 sm:px-6 lg:px-8 mb-[30px] sm:mb-[45px] lg:mb-[60px] sm:hidden">
        <div className="w-full max-w-[1182px] bg-global-text4 bg-global-1 mx-auto rounded-[24px] overflow-hidden bg-beige-100 lg:bg-transparent">
          <div className="lg:flex lg:bg-transparent rounded-[24px] overflow-hidden">
            {/* Content: النص + الأزرار */}
            <div
              className="w-full bg-beige-100 h-[365px] p-6 ..."
              style={{
                backgroundImage: "url('/assets/images/rec-9m.png')",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                backgroundPosition: "center",
                textAlign: "center",
              }}
            >
              <h1 className="text-global-3 text-darkblue-900 text-[26px] sm:text-[39px] lg:text-[52px] font-extrabold capitalize">
                {t("one_more_friend")}
              </h1>
              <h2 className="text-global-3 text-darkblue-900 text-[18px] sm:text-[27px] lg:text-[36px] font-bold mb-4 capitalize">
                {t("thousands_more_fun")}
              </h2>
              <p className="text-darkblue-900 text-[12px] sm:text-[14px] lg:text-[16px] mb-6 max-w-[380px]">
                {t("having_pet")}
              </p>

              {/* Buttons */}
              <div className="flex flex-col sm:flex-row gap-[10px] lg:pl-[80px] sm:gap-[15px] lg:gap-[20px] mx-auto">
                <Button
                  variant="outline"
                  onClick={() => {}} // Add required onClick prop
                  className="border border-global-text4 text-global-text4 rounded-[24px] px-[14px] sm:px-[21px] lg:px-[28px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] w-full sm:w-auto justify-center"
                >
                  {t("view_intro")}
                  <img
                    src="assets/images/img_media_playcircle.svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px]"
                    alt=""
                  />
                </Button>
                <Button
                  variant="primary"
                  onClick={() => {}} // Add required onClick prop
                  className="bg-global-text4 text-global-text8 rounded-[24px] px-[17px] sm:px-[26px] lg:px-[34px] py-[7px] sm:py-[11px] lg:py-[14px] w-full sm:w-auto"
                >
                  {t("explore_now")}
                </Button>
              </div>
            </div>

            {/* Image Section */}
            <div className="w-full lg:w-[50%] bg-[url('assets/images/img_rec1.png')] bg-cover bg-center p-[10px] sm:p-[15px] lg:p-[20px] flex justify-center items-end">
              <img
                src="assets/images/with_owner.png"
                alt="Pet with owner"
                className="object-cover w-full max-w-[400px] sm:max-w-[512px] h-auto"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Products Section */}
      <section className="w-full py-[30px] sm:py-[45px] lg:py-[60px] px-[20px] sm:px-[20px] lg:px-[56px]">
        <div className="w-full max-w-[1182px] mx-auto">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[14px] sm:mb-[21px] lg:mb-[28px]">
            <div className="mb-4 sm:mb-0">
              <h2 className="text-[18px] sm:text-[21px] lg:text-[24px] font-svn-gilroy font-bold leading-[20px] sm:leading-[23px] lg:leading-[26px] text-global-text4 capitalize">
                {t("featuredProducts")}
              </h2>{" "}
              <p className="pt-4 text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text1 mb-[2px] sm:mb-[3px] lg:mb-[4px]">
                {t("hard_to_shop")}
              </p>
            </div>

            {/* زر العرض بجانب العنوان - مخفي في الشاشات الصغيرة */}
            <Button
              variant="outline"
              onClick={() =>
                (window.location.href = "/product-listing?featured=true")
              }
              className="border border-global-text4 text-global-text4 rounded-[22px] px-[24px] sm:px-[36px] lg:px-[48px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[11px] sm:text-[12px] lg:text-[14px] hidden sm:flex"
            >
              {t("view_more")}
           
            </Button>
          </div>

          <FeaturedProducts />

          {/* زر العرض تحت FeaturedProducts في الشاشات الصغيرة فقط */}
          <div className="mt-6 block sm:hidden">
            <Button
              variant="outline"
              onClick={() =>
                (window.location.href = "/product-listing?featured=true")
              }
              className="w-full border border-global-text4 text-global-text4 rounded-[22px] py-[12px] flex items-center justify-center gap-[8px] text-[14px]"
            >
              {t("view_more")}
           
            </Button>
          </div>
        </div>
      </section>

      {/* Adoption Section */}
      <section
        dir="ltr"
        className="w-full px-4 sm:px-6 lg:px-8 mb-[30px] sm:mb-[45px] lg:mb-[60px] hidden sm:block"
      >
        <div className="w-full max-w-[1182px] mx-auto bg-global-5 rounded-[20px] relative overflow-hidden">
          <div className="flex flex-col lg:flex-row">
            {/* Left Side - Content */}
            <div
              className="w-full lg:w-[60%] bg-cover bg-center p-[28px] sm:p-[42px] lg:p-[56px] flex items-end"
              style={{ backgroundImage: "url('/assets/images/rec_12.png')" }}
            >
              <div className="w-full max-w-[460px]">
                <div className="flex items-center gap-4">
                  <h1 className="text-[36px] sm:text-[44px] lg:text-[52px] font-extrabold text-[#032a4c] capitalize font-svn-gilroy leading-tight">
                    Adoption
                  </h1>
                  <img
                    src="assets/images/fontisto_paw.svg"
                    className="w-[32px] h-[29px]"
                    alt="Paw icon"
                  />
                </div>

                <h2 className="mt-4 text-[24px] sm:text-[28px] lg:text-[32px] font-bold text-[#032a4c] capitalize font-svn-gilroy leading-snug">
                  {t("we_need")}
                </h2>

                <p className="mt-2 text-[13px] sm:text-[15px] lg:text-[16px] font-medium text-[#333333] leading-relaxed font-svn-gilroy max-w-[350px]">
                  {t("adopt")}
                </p>

                <div className="mt-6 flex gap-4">
                  <Button
                    variant="primary"
                    onClick={() => {}}
                    className="bg-[#032a4c] text-white rounded-[30px] px-8 py-3 text-[16px] font-semibold"
                  >
                    {t("explore_now")}
                  </Button>
                  <Button
                    variant="outline"
                    onClick={() => {}}
                    className="border border-[#032a4c] text-[#032a4c] rounded-[30px] px-8 py-3 flex items-center gap-2 text-[16px] font-semibold"
                  >
                    {t("view_intro")}
                    <img
                      src="assets/images/img_media_playcircle.svg"
                      className="w-6 h-6"
                      alt="Play icon"
                    />
                  </Button>
                </div>
              </div>
            </div>

            {/* Right Side - Image */}
            <div className="w-full lg:w-[52%] -ml-0 lg:-ml-[114px] flex justify-end items-end relative z-[200]">
              <img
                src="assets/images/img_rectangle_1_348x734.png"
                className="w-[367px] sm:w-[551px] lg:w-[734px] h-[174px] sm:h-[261px] lg:h-[348px] object-cover rounded-[49px] sm:rounded-[74px] lg:rounded-[98px] relative z-[200]"
                alt="Pet adoption"
              />
            </div>
          </div>

          {/* Pet Image Overlay */}
          <div className="absolute top-20 right-0 w-[292px] sm:w-[438px] lg:w-[584px] h-[189px] sm:h-[284px] lg:h-[378px]">
            <img
              src="assets/images/rec_13.png"
              className="w-full h-full object-cover"
              alt="Pet overlay"
              style={{ zIndex: 100 }}
            />
          </div>
        </div>
      </section>

      {/*  <section className="w-full py-[19px] sm:py-[29px] lg:py-[38px]">
        <div className="w-full max-w-[1182px] mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[7px] sm:mb-[11px] lg:mb-[14px]">
            <div className="flex items-center mb-4 sm:mb-0">
           
              <span className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text1 mr-[4px] sm:mr-[6px] lg:mr-[8px]">
                Proud to be part of
              </span>
              <h2 className="text-[18px] sm:text-[21px] lg:text-[24px] font-svn-gilroy font-bold leading-[20px] sm:leading-[23px] lg:leading-[26px] text-global-text4 capitalize">
                Pet Sellers
              </h2>
            </div>
            <Button
              variant="outline"
              onClick={() => {}} 
              className="border border-global-text4 text-global-text4 rounded-[22px] px-[24px] sm:px-[36px] lg:px-[48px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[11px] sm:text-[12px] lg:text-[14px]"
            >
              View all our sellers
              <img
                src="assets/images/img_arrowright.svg"
                className="w-[15px] sm:w-[18px] lg:w-[20px] h-[15px] sm:h-[18px] lg:h-[20px]"
                alt="Arrow right"
              />
            </Button>
          </div>

          <div className="flex flex-wrap justify-center items-center gap-[10px] sm:gap-[15px] lg:gap-[20px]">
            {brands?.map((brand) => (
              <div
                key={brand?.id}
                className="flex justify-center items-center p-[12px] sm:p-[18px] lg:p-[24px]"
              >
                <img
                  src={brand?.image}
                  className="max-w-[60px] sm:max-w-[90px] lg:max-w-[120px] max-h-[40px] sm:max-h-[60px] lg:max-h-[80px] object-contain"
                  alt={`Brand ${brand?.id}`}
                />
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      {/* Knowledge Section */}
      <section className="w-full py-[30px] sm:py-[45px] lg:py-[60px] px-[28px] sm:px-[42px] lg:px-[56px]">
        <div className="w-full max-w-[1182px] mx-auto">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[14px] sm:mb-[21px] lg:mb-[28px]">
            <div className="mb-4 sm:mb-0">
              <h2 className="text-[18px] sm:text-[21px] lg:text-[24px] font-svn-gilroy font-bold leading-[20px] sm:leading-[23px] lg:leading-[26px] text-global-text4 capitalize">
                {t("useful_pet_knowledge")}
              </h2>
            </div>
            {/* <Button
              variant="outline"
              onClick={() => {}} // Add required onClick prop
              className="border border-global-text4 text-global-text4 rounded-[22px] px-[24px] sm:px-[36px] lg:px-[48px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[11px] sm:text-[12px] lg:text-[14px]"
            >
              {t("view_more")}
              <img
                src="assets/images/img_arrowright.svg"
                className="w-[15px] sm:w-[18px] lg:w-[20px] h-[15px] sm:h-[18px] lg:h-[20px]"
                alt="Arrow right"
              />
            </Button>*/}
          </div>

          <div className="flex flex-col lg:flex-row gap-[10px] sm:gap-[15px] lg:gap-[20px]">
            {articles?.map((article, index) => (
              <div
                key={article?.id}
                className="bg-global-6 rounded-[12px] p-[4px] sm:p-[6px] lg:p-[8px] shadow-[0px_4px_28px_#00000014] w-full lg:w-[380px]"
              >
                <div className="bg-global-6 rounded-[10px] mb-[4px] sm:mb-[6px] lg:mb-[8px]">
                  <img
                    src={article?.image}
                    className="w-full h-[120px] sm:h-[180px] lg:h-[240px] object-cover rounded-[10px]"
                    alt={t(`articles.${index + 1}.title`)}
                  />
                </div>
                <div className="p-[4px] sm:p-[6px] lg:p-[8px]">
                  <div className="flex flex-col gap-[5px] sm:gap-[8px] lg:gap-[10px]">
                    <Button
                      variant="primary"
                      onClick={() => {}} // Add required onClick prop
                      className="bg-button-1 text-global-text8 rounded-[10px] px-[5px] sm:px-[8px] lg:px-[10px] py-[1px] sm:py-[1.5px] lg:py-[2px] text-[8px] sm:text-[9px] lg:text-[10px] w-fit"
                    >
                      {t(`articles.${index + 1}.category`)}
                    </Button>
                    <div className="flex flex-col gap-[3px] sm:gap-[4px] lg:gap-[6px]">
                      <h3 className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-bold leading-[18px] sm:leading-[21px] lg:leading-[24px] text-global-text2">
                        {t(`articles.${index + 1}.title`)}
                      </h3>
                      <p className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-normal leading-[15px] sm:leading-[18px] lg:leading-[20px] text-global-text5">
                        {t(`articles.${index + 1}.description`)}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      {/* Footer
      <footer className="w-full bg-[linear-gradient(134deg,#fbeed4_0%,#fbeed4_50%,#ffe6b9_100%)] rounded-t-[40px] pt-[20px] sm:pt-[30px] lg:pt-[40px] px-[20px] sm:px-[30px] lg:px-[40px] pb-[20px] sm:pb-[30px] lg:pb-[40px]">
        <div className="w-full max-w-[1182px] mx-auto">
          <div className="flex flex-col gap-[20px] sm:gap-[30px] lg:gap-[40px]">
     
            <div className="bg-global-text4 rounded-[16px] p-[16px] sm:p-[24px] lg:p-[32px]">
              <div className="flex flex-col lg:flex-row gap-[10px] sm:gap-[15px] lg:gap-[20px] items-start lg:items-center">
                <h3 className="text-[12px] sm:text-[18px] lg:text-[24px] font-svn-gilroy font-bold leading-[18px] sm:leading-[27px] lg:leading-[36px] text-global-text8 capitalize w-full lg:w-[34%]">
                  {t("register_now")}
                </h3>
                <div className="bg-global-6 rounded-[14px] p-[6px] sm:p-[9px] lg:p-[12px] flex flex-col sm:flex-row gap-[6px] sm:gap-[9px] lg:gap-[12px] w-full lg:flex-1">
                  <input
                    type="email"
                    placeholder={t("emailPlaceholder")}
                    className="flex-1 bg-global-6 border border-global-text7 rounded-[8px] px-[14px] sm:px-[21px] lg:px-[28px] py-[7px] sm:py-[11px] lg:py-[14px] text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text7 focus:outline-none focus:ring-2 focus:ring-global-text4"
                  />
                  <Button
                    variant="primary"
                    onClick={() => {}} // Add required onClick prop
                    className="bg-global-text4 text-global-text8 rounded-[8px] px-[15px] sm:px-[23px] lg:px-[30px] py-[7px] sm:py-[11px] lg:py-[14px] text-[12px] sm:text-[14px] lg:text-[16px] w-full sm:w-auto"
                  >
                    {t("subscribe")}
                  </Button>
                </div>
              </div>
            </div>

       
            <div className="border-b border-global-2 pb-[20px] sm:pb-[30px] lg:pb-[40px]">
              <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center">
                <div className="flex flex-col sm:flex-row gap-[30px] sm:gap-[45px] lg:gap-[60px] mb-6 sm:mb-0">
                  <span className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors">
                    {t("navigation.home")}
                  </span>
                  <span className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors">
                    {t("navigation.categories")}
                  </span>
                  <button
                    onClick={() => navigate("/about-us")}
                    className="text-[12px] sm:text-[14px] lg:text-[16px] font-svn-gilroy font-medium leading-[13px] sm:leading-[15px] lg:leading-[17px] text-global-text2 cursor-pointer hover:text-global-text4 transition-colors"
                  >
                    {t("navigation.aboutUs")}
                  </button>
                </div>
                <div className="flex gap-[20px] sm:gap-[30px] lg:gap-[40px]">
                  <img
                    src="assets/images/facebook.svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                    alt="Facebook"
                  />
                  <img
                    src="assets/images/twiter.svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                    alt="Twitter"
                  />
                  <img
                    src="assets/images/instagram.svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                    alt="Instagram"
                  />
                  <img
                    src="assets/images/youTube .svg"
                    className="w-[18px] sm:w-[21px] lg:w-[24px] h-[18px] sm:h-[21px] lg:h-[24px] cursor-pointer hover:opacity-80 transition-opacity"
                    alt="YouTube"
                  />
                </div>
              </div>
            </div>

      
            <div className="flex flex-col sm:flex-row justify-between items-center">
              <span className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text6 mb-4 sm:mb-0">
                {t("footerText")}
              </span>

              <div className="flex flex-col items-center gap-[2px] sm:gap-[3px] lg:gap-[4px] mb-4 sm:mb-0">
                <img
                  src="assets/images/logo.png"
                  className="w-[57px] sm:w-[86px] lg:w-[86px] h-[13px] sm:h-[20px] lg:h-[50px]"
                  alt="Monito Logo"
                />
              </div>

              <span className="text-[11px] sm:text-[12px] lg:text-[14px] font-svn-gilroy font-medium leading-[12px] sm:leading-[13px] lg:leading-[15px] text-global-text6">
                {t("privacyProtected")}
              </span>
            </div>
          </div>
        </div>
      </footer>*/}
    </div>
  );
};

export default Home;
